export default {
  Visa: "fa-cc-visa",
  MasterCard: "fa-cc-mastercard",
  "American Express": "fa-cc-amex",
  Discover: "fa-cc-discover",
};
